<template>
  <div
    :ref="chartRefId"
    style="width: 100%; height: 400px;"
  ></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'PieChart',

  props: {
    config: {
      type: Object,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      chartRefId: 'pie-chart-' + this._uid,
      chartInstance: null
    };
  },

  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },

  watch: {
    config: {
      deep: true,
      handler: function () {
        this.updateChart();
      }
    },
    data: {
      deep: true,
      handler: function () {
        this.updateChart();
      }
    }
  },

  methods: {
    initChart() {
      var el = this.$refs[this.chartRefId];
      if (!el) return;

      this.chartInstance = echarts.init(el);

      this.updateChart();
    },

    buildOption() {
      var labelField = this.config.labelField;
      var valueField = this.config.valueField;

      var i;
      var item;
      var pieData = [];

      for (i = 0; i < this.data.length; i++) {
        item = this.data[i];

        pieData.push({
          name: item[labelField],
          value: item[valueField] !== undefined && item[valueField] !== null
            ? Number(item[valueField])
            : 0
        });
      }

      return {
        title: {
          text: this.config.title || '',
          left: 'center'
        },

        tooltip: {
          trigger: 'item'
        },

        legend: this.config.showLegend
          ? {
              orient: 'vertical',
              left: 'left'
            }
          : undefined,

        series: [
          {
            type: 'pie',
            radius: this.config.radius || '50%',

            data: pieData,

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
    },

    updateChart() {
      if (!this.chartInstance) return;

      this.chartInstance.clear();
      this.chartInstance.setOption(this.buildOption(), true);
    },

    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }, 

    getChartInstance() {
      return this.chartInstance;
    }
  },

  beforeUnmount: function () {
    window.removeEventListener('resize', this.resizeChart);

    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>